"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  var hubspotBasePathnameRegex = /^\/[\w-]+\/\d+/;
  var parts = window.location.pathname.match(hubspotBasePathnameRegex);
  return parts ? parts[0] : null;
};

exports.default = _default;
module.exports = exports.default;